import { useEffect, useState } from "react";
import { marked } from "marked";
import "./EtsgPrivacyPage.scss";

const PrivacyPolicyPage = () => {
  const [html, setHtml] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const prev = document.title;
    document.title = "Privacy Policy — Labwick";
    return () => {
      document.title = prev;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/privacy.md");
        if (!res.ok) throw new Error(`Failed to load: ${res.status}`);
        const md = await res.text();
        const parsed = await marked.parse(md);
        if (!cancelled && typeof parsed === "string") setHtml(parsed);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Failed to load privacy policy");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen min-w-full items-center justify-center bg-white p-8 dark:bg-gray-900">
        <p className="text-gray-600 dark:text-gray-400">Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen min-w-full items-center justify-center bg-white p-8 dark:bg-gray-900">
        <p className="text-red-600 dark:text-red-400">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen min-w-full bg-white dark:bg-gray-900">
      <article
        className="etsg-privacy mx-auto max-w-3xl px-6 py-10 text-gray-800 dark:text-gray-200"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

export default PrivacyPolicyPage;
